import {connect} from 'react-redux';

import {CalendarsPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {SchedulingLinkStandardAvailabilityBlockModel} from '../../../../models/api/schedulingLinkModel';
import {getHasNoCalendars} from '../../../../store/data/calendarVersions/calendarVersionsSelectors';
import {getShouldCalendarDisplayWeekends} from '../../../../store/data/preferences/preferencesSelectors';
import {updateCalendarFocusedDateAction} from '../../../../store/panels/calendars/calendarsPanelActions';
import {
  makeGetCalendarsPanel,
  makeGetCalendarsParameters,
} from '../../../../store/panels/calendars/calendarsPanelSelectors';
import {
  getDraftSchedulingLink,
  getSchedulingStatus,
  getTrueAvailabilityStatus,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingSelectors';
import {StandardAvailabilityCalendar} from './standardAvailabilityCalendar';

/*
 * Props.
 */

interface StandardAvailabilityCalendarContainerProps {
  panelId: CalendarsPanelId;
  selectedSlots: ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel>;
  setSelectedSlots: (arg: ReadonlyArray<SchedulingLinkStandardAvailabilityBlockModel>) => void;
}

/*
 * Selectors.
 */

function makeGetFocusedDate(getParameters: ReturnType<typeof makeGetCalendarsParameters>) {
  return createSelector([getParameters], (parameters) => parameters.focusedDate);
}

const getMeetingDuration = createSelector(
  [getDraftSchedulingLink],
  (draftSchedulingLink) => draftSchedulingLink.meetingProperties.durationMinutes,
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<StandardAvailabilityCalendarContainerProps>()(() => {
  const getCalendarsPanel = makeGetCalendarsPanel();
  const getParameters = makeGetCalendarsParameters(getCalendarsPanel);
  const getFocusedDate = makeGetFocusedDate(getParameters);

  return {
    hasNoCalendars: getHasNoCalendars,
    shouldCalendarDisplayWeekends: getShouldCalendarDisplayWeekends,
    focusedDate: getFocusedDate,
    meetingDuration: getMeetingDuration,
    trueAvailabilityStatus: getTrueAvailabilityStatus,
    status: getSchedulingStatus,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<StandardAvailabilityCalendarContainerProps>()(
  ({panelId}) => ({
    onFocusedDateSelect: (focusedDate) => updateCalendarFocusedDateAction(panelId, focusedDate),
  }),
);

export const StandardAvailabilityCalendarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StandardAvailabilityCalendar);
